var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 470,
    height: 468,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "111.8%",
    height: "111.9%",
    x: "-5.9%",
    y: "-3.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.078125 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.210824275 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M9.635 132.808C24.782 59.782 71.388 19.109 144.085 6.822c53.74-9.081 107.5-9.196 161.15.255 74.852 13.185 119.85 56.23 134.185 130.36 11.075 57.29 11.249 115.191-.174 172.427-15.324 72.52-63.132 117.285-135.561 129.527-53.74 9.08-107.5 9.195-161.15-.255-74.852-13.186-120.05-58.38-134.384-132.509-11.64-57.668-10.52-115.935 1.484-173.82z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0BCD74",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m153.802 192.926 18.935-6.963s14.595 29.09 43.41 57.905c28.814 28.814 60.712 44.448 60.712 44.448l-8.173 19.126s-35.922-20.794-65.62-50.492c-29.699-29.698-49.264-64.024-49.264-64.024zM365.55 283c12.825 6.377 15.614 23.454 5.486 33.582l-43.41 43.41a28.307 28.307 0 0 1-24.433 7.955 212.55 212.55 0 0 1-8.853-1.597c-26.501-3.598-78.636-17.094-128.75-67.21-52.9-52.9-67.984-112.162-72.243-139.154a28.309 28.309 0 0 1 7.953-24.433l43.412-43.411c10.127-10.128 27.205-7.338 33.582 5.487l33.504 67.38-16.745 8.269L164 110.382c-1.804-3.653-6.662-4.454-9.543-1.573l-35.546 35.545a18.807 18.807 0 0 0-5.493 14.046c.606 15.378 5.157 44.93 27.353 80.562 9.118 13.6 20.96 28.27 36.349 43.66 53.234 53.235 101.455 63.534 124.62 65.086 3.156-.063 5.637-.29 7.37-.51 2.291-.29 4.52-1.004 6.474-2.232a18.591 18.591 0 0 0 3.24-2.583l35.546-35.546c2.882-2.881 2.08-7.74-1.572-9.543L289.9 266.24l8.267-16.746L365.55 283z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.830a8c380fb9937862f68ff1a26e93ba.svg";
export { ForwardRef as ReactComponent };